"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tokens = void 0;
var _globalTokens = require("../../../shared/global-tokens");
var tokens = exports.tokens = {
  background: {
    color: _globalTokens.globalColor.background.neutral[1]
  },
  shadow: "box-shadow: 0 ".concat(_globalTokens.globalSizing['100'], "  ").concat(_globalTokens.globalSizing['400'], " rgba(0, 0, 0, 0.12);"),
  border: {
    default: "".concat(_globalTokens.globalBorder.width.thin, " solid ").concat(_globalTokens.globalColor.border.separator, ";"),
    radius: _globalTokens.globalBorder.radius[3]
  },
  padding: {
    default: _globalTokens.globalSpacing['400']
  }
};